<template>
  <!-- <v-container fluid class="mx-0 my-0 py-0 px-0" fill-height> -->
  <!-- <v-skeleton-loader v-if="loading" type="image" height="100vh" /> -->
  <div>
    <TerritoryInfo v-if="this.areaSelected" />
    <Map
      :soilAreasTerritory="soilAreasTerritory"
      :isDetailOpen="this.areaSelected"
      :isAddPolygon="this.isAddSoilSample"
      :removeFromMapCurrentArea="this.removeFromMapCurrentArea"
      :isRedraw="this.isRedraw"
    />
  </div>

  <!-- <router-view></router-view> -->
  <!-- </v-container> -->
</template>

<script>
// Vuex
import { mapState, mapMutations, mapActions } from "vuex";

// Components
import Map from "@/components/territory/Map";
import TerritoryInfo from "@/components/territory/TerritoryInfo";

export default {
  components: {
    Map,
    TerritoryInfo,
  },
  data() {
    return {
      organizationId: "",
      token: "",
      soilAreasTerritory: [],
      loading: false,
    };
  },
  created() {
    this.token = localStorage.getItem("token");
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
      this.SET_CLIENT("");
      this.organizationId = localStorage.getItem("organizationId");
      if (this.areaSelected) {
        this.SET_APPBAR_OPTIONS({
          leftButton: "menu",
        });
      } else {
        this.SET_APPBAR_OPTIONS({
          leftButton: "menu",
          rightButton: "listAreas",
        });
      }
    } else {
      let client = JSON.parse(localStorage.getItem("client"));
      if (client && client.companyName) {
        this.SET_CLIENT(client.companyName);
      }
      this.organizationId = localStorage.getItem("clientId");
      if (this.areaSelected) {
        this.SET_APPBAR_OPTIONS({
          leftButton: "menu_seller",
          funcLeftButton: this.goBack,
        });
      } else {
        this.SET_APPBAR_OPTIONS({
          leftButton: "menu_seller",
          funcLeftButton: this.goBack,
          rightButton: "listAreas",
        });
      }
    }
    if (this.token) {
      this.getSoilAreas();
    }
    this.scrollTop();
  },
  computed: {
    ...mapState("areasList", [
      "soilAreas",
      "areaSelected",
      "isAddSoilSample",
      "removeFromMapCurrentArea",
      "isRedraw",
    ]),
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations("user", ["SET_CLIENT"]),
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    ...mapActions("areasList", ["fetchAllAreas"]),
    ...mapMutations("areasList", ["CLEAR_AREA_STATE"]),
    ...mapMutations(["SET_LOADER"]),

    async getSoilAreas() {
      this.SET_LOADER(true);
      try {
        this.loading = true;
        const response = await this.fetchAllAreas(this.organizationId);
        // add to map
        this.soilAreasTerritory = this.soilAreas;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: error,
          timeout: 4000,
        });
      }
      this.SET_LOADER(false);
    },
    goBack() {
      this.CLEAR_AREA_STATE();
      this.$router.push(`/seller-list/client/`);
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
.transparent_buttton {
  background-color: "trasparent" !important;
  border-color: "#D9FFFFFF" !important;
}
</style>
